import { PlatformId } from "views/page-content/platforms/types";
import { YouTubePlatformSettings } from "./platforms/YouTubePlatformSettings";
import { RtmpPlatformSettings } from "./platforms/RtmpPlatformSettings";
import { FacebookPlatformSettings } from "./platforms/FacebookPlatformSettings";
import { TwitchPlatformSettings } from "./platforms/TwitchPlatformSettings";
import { PlatformSubheader } from "views/page-content/platforms/PlatformsPageV2/PlatformsTableV2/PlatformSubheader";
import styles from "./index.module.scss";
import { useMemo } from "react";
import { FacebookEdge } from "api/facebook/types";

interface PlatformSettingsProps {
    selectedPlatform: PlatformId;
    selectedDestinationId: string | null;
    setHasAddedPlatformSpecificSettings: (value: boolean) => void;
    setOnAdvanceStep: (callback: () => void) => void;
    setOnDismiss: (callback: () => void) => void;
    advanceStep: () => void;
    setCurrentFacebookEdge: (edge: FacebookEdge) => void;
}

export const PlatformSettings = ({
    selectedPlatform,
    selectedDestinationId,
    setHasAddedPlatformSpecificSettings,
    setOnAdvanceStep,
    setOnDismiss,
    advanceStep,
    setCurrentFacebookEdge
}: PlatformSettingsProps) => {
    const platformSettingsElement = useMemo(() => {
        switch (selectedPlatform) {
            case PlatformId.Youtube:
                return (
                    <YouTubePlatformSettings
                        setHasAddedPlatformSpecificSettings={
                            setHasAddedPlatformSpecificSettings
                        }
                        setOnAdvanceStep={setOnAdvanceStep}
                        setOnDismiss={setOnDismiss}
                        selectedDestinationId={selectedDestinationId}
                    />
                );
            case PlatformId.Facebook:
                return (
                    <FacebookPlatformSettings
                        setHasAddedPlatformSpecificSettings={
                            setHasAddedPlatformSpecificSettings
                        }
                        setOnAdvanceStep={setOnAdvanceStep}
                        setOnDismiss={setOnDismiss}
                        selectedDestinationId={selectedDestinationId}
                        setCurrentFacebookEdge={setCurrentFacebookEdge}
                    />
                );
            case PlatformId.Twitch:
                return (
                    <TwitchPlatformSettings
                        setHasAddedPlatformSpecificSettings={
                            setHasAddedPlatformSpecificSettings
                        }
                        setOnAdvanceStep={setOnAdvanceStep}
                        setOnDismiss={setOnDismiss}
                        selectedDestinationId={selectedDestinationId}
                    />
                );
            case PlatformId.Rtmp:
                return <RtmpPlatformSettings advanceStep={advanceStep} />;
            default:
                return <div>This platform is not yet implemented</div>;
        }
    }, [
        selectedPlatform,
        setHasAddedPlatformSpecificSettings,
        setOnAdvanceStep,
        setOnDismiss,
        selectedDestinationId,
        advanceStep,
        setCurrentFacebookEdge
    ]);

    const showSubheader = useMemo(() => {
        return (
            selectedPlatform === PlatformId.Youtube ||
            selectedPlatform === PlatformId.Facebook
        );
    }, [selectedPlatform]);

    return (
        <>
            {showSubheader && (
                <div className={styles["platform-subheader-wrapper"]}>
                    <PlatformSubheader platformId={selectedPlatform} />
                </div>
            )}
            {platformSettingsElement}
        </>
    );
};
